/**
 * training-groups-drawer.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { paths } from 'utils/routing';
import MenuDrawer from 'components/menu-drawer';
import { trainingPath } from './training-groups';
import TrainingGroupsMenu from './training-groups-menu';
import TrainingGroup from './training-group';


const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      '& .scrollable-list ul': {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4)
      }
    }
  }
}));


export default function TrainingGroupsDrawer(props) {
  const classes = useStyles();
  const history = useHistory();
  const basePath = useRouteMatch();
  const drawerPath = `/${trainingPath}`;


  const onCloseDrawer = () => {
    if (props.onClose) {
      props.onClose();
    }
    history.push(basePath.url);
  } 


  return (
    <div className={classes.root}>
      <MenuDrawer
        {...props}
        title='EDIT TRAINING GROUP'
        className='training-group-drawer'
        basePath={basePath.url}
        drawerPath={drawerPath}
        onClose={onCloseDrawer}
        menuRoutes={[{
          component: TrainingGroupsMenu,
          path: [basePath.url + paths.groups.trainingGroup.path]
        }]}
        desktopRoutes={[{
          component: TrainingGroup,
          path: [basePath.url + paths.groups.trainingGroup.path]
        }]}
        mobileRoutes={[{
          component: TrainingGroup,
          path: [basePath.url + paths.groups.trainingGroup.path]
        }, {
          component: TrainingGroupsMenu,
          path: [basePath.url + paths.groups.typeMenu.path]
        }]}
      />
    </div>
  )
}